
document.addEventListener('DOMContentLoaded', function() {
  var tooltipContainers = document.querySelectorAll('.tooltip-container');

    tooltipContainers.forEach(function(container) {
      container.addEventListener('click', function(e) {
        // On mobile (<= 768px), toggle tooltip on click
        if (window.innerWidth <= 768) {
          e.stopPropagation();
          this.classList.toggle('active');
        }
      });
    });

    // Close any open tooltip if user taps outside
    document.addEventListener('click', function(e) {
      if (window.innerWidth <= 768) {
        tooltipContainers.forEach(function(container) {
          if (!container.contains(e.target)) {
            container.classList.remove('active');
          }
        });
      }
    });
  // Select the add-to-cart form by its data attribute
  var form = document.querySelector('form[data-type="add-to-cart-form"]');
if (form) {
  var extraInput = document.getElementById('extras_product');
  var mattressInputs = document.querySelectorAll('.mattress_products');

  form.addEventListener('submit', async function(e) {
    e.preventDefault();

    // Show spinner and hide "Add to cart" text
    var submitButton = form.querySelector('.custom-product-form__submit');
    var buttonText = submitButton.querySelector('.t4s-btn-atc_text');
    var spinner = submitButton.querySelector('.t4s-loading__spinner');
    var spinnerSvg = submitButton.querySelector('.t4s-loading__spinner svg');

    if (buttonText && spinner) {
      buttonText.setAttribute('hidden', '');
      spinner.removeAttribute('hidden');
      spinnerSvg.removeAttribute('hidden');
    }

    var extraVariantId = extraInput ? extraInput.getAttribute('data-extra-values') : '';
    var mattressVariantIds = [];

    mattressInputs.forEach(function(input) {
      var dataValues = input.getAttribute('data-array-values');
      if (dataValues) {
        var ids = dataValues.split(',').map(id => id.trim());
        mattressVariantIds = mattressVariantIds.concat(ids);
      }
    });

    if (extraVariantId) {
      mattressVariantIds.push(extraVariantId);
    }

    async function addVariantsSequentially(variants, delay = 200) {
      for (var i = 0; i < variants.length; i++) {
        var variantId = variants[i];
        try {
          let response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          if (!response.ok) throw new Error('Failed to add variant with id ' + variantId);
          await response.json();
        } catch (error) {
          console.error('Error adding variant with id ' + variantId + ':', error);
        }
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }

    await addVariantsSequentially(mattressVariantIds, 200);

    form.removeEventListener('submit', arguments.callee);
    form.submit();
  });
}

});
